import { STORAGE_KEY } from "../global_settings";
import { updateOverviewProgress, updateSectionProgress } from "../progress/progress";
import { ChecklistState } from "../state/state";
import { getChecklistStats } from "../state/stateStats";
import { loadState, saveState } from "../storage/storage";
import { getPageId } from "../utils/utils";



/**
 * Extracts all list elements that represent a checklist item
 * @returns
 */
export function getDACheckboxItems(): Array<HTMLLIElement> {
  /**
   * DA checkboxes are children of:
   * <article class="md-content__inner md-typeset">
   *      <ul class="task-list">
   *            <li class="task-list-item">
   * article.md-content__inner.md-typeset > ul.task-list > li.task-list-item
   *    `>` shows a direct parent child link
   *    ` ` would show an indirect parent child link
   */
  const checkbox_querySelector = "article.md-content__inner.md-typeset > ul.task-list > li.task-list-item"

  return [...document.querySelectorAll<HTMLLIElement>(checkbox_querySelector)];

}

/**
 * Extract an id added as a comment into the markdown
 * <!-- id:slug_id-name -->
 * @param daCheckboxItem
 * @returns
 */
export function extractMarkdownID(daCheckboxItem: HTMLLIElement): string | null {
  const match = daCheckboxItem.innerHTML.match(/id:([a-zA-Z0-9-_]+)/);
  return match ? match[1] : null;
}

/**
 * is the ID in somewhere in the saved ChecklistState?
 * @param id
 * @param state
 * @returns
 */
export function isIDinState(id: string, state: ChecklistState): boolean {
  for (const [sectionName, _] of Object.entries(state)) {
    if (id in state[sectionName].items) {
      return true
    }
  }

  return false
}

/**
 * Adds an ID to individual checklist items if it is known in state:
 *   `<li class='task-list-item' id='[...]'>`
 * ID is extracted with `extractMarkdownID`
 * @param checkboxItem `<li class='task-list-item'>`
 * @param state `ChecklistState`
 */
export function addDA_ID_ToCheckboxes(checkboxItem: HTMLLIElement, state: ChecklistState): void {
  const extractedID = extractMarkdownID(checkboxItem);
  if (
    extractedID &&
    isIDinState(extractedID, state)
   ) {
      checkboxItem.id = extractedID;
    } else {
      console.debug(`ID not found or not in state:`, extractedID )
    }

}

function persistAndRefresh(state: ChecklistState) {
    saveState(state);

    const stats = getChecklistStats(state);
    updateOverviewProgress(stats);
    updateSectionProgress(stats);
}

/**
 * Add an event listener to a checkbox
 * @param checkbox
 * @param id
 * @param state
 * @param slug
 */
function addCheckboxEventListners(
  checkbox: HTMLLIElement,
  id: string,
  state: ChecklistState,
  slug: string
) {
  const checkboxElement = checkbox.querySelector<HTMLInputElement>("input");
    checkboxElement?.addEventListener("change", () => {
      const pages = appearsOnOtherPages(id, state);
      for (const page of pages) {
        state[page].items[id].checked = checkboxElement.checked;
        console.debug("toggled checkbox:", id, "on page:", page)

      }
      persistAndRefresh(state);
    });
}

export function toggleCheckboxBasedOnState(checkbox: HTMLLIElement, id: string, state: ChecklistState, pageSlug: string): void {
  const toggle: HTMLInputElement | null = checkbox.querySelector("input");
  if (toggle) {
    toggle!.checked = state[pageSlug].items[id].checked;
  } else {
    console.warn("no toggle", checkbox.innerHTML);
  }

}

export function appearsOnOtherPages(id: string, state: ChecklistState): Array<string> {
  const pages = new Array;
  for (const [sectionName, _] of Object.entries(state)) {
    if (id in state[sectionName].items) {
      pages.push(sectionName)
    }
  }
  return pages
}

export function checkboxHandler(
  // checkboxItem: HTMLLIElement,
  storage_key: string = STORAGE_KEY,
  slug: string = getPageId()
): void {

  if (slug === "index") {
    console.warn("On page `index` there may be an issue");
  }
  // load state
  let state = loadState(storage_key);
  // get all checkbox items
  const checkboxes = getDACheckboxItems();
  for (const checkbox of checkboxes) {
    // extract the checkbox id
    const cbID = extractMarkdownID(checkbox);
    // if ID is unknown or not in state, log it to the console
    if (cbID === null || !isIDinState(cbID, state)) {
      console.warn("ID not known or not stored in state file", cbID);
      continue
    } else {
      if (checkbox.id !== cbID) {
        // adds ids to the <li element> if not already added
        addDA_ID_ToCheckboxes(checkbox, state);
      }
      // toggle checkbox based off state
      toggleCheckboxBasedOnState(checkbox, cbID, state, slug)
      // add event listeners
      addCheckboxEventListners(checkbox, cbID, state, slug)
    }
  }
  // regardless of what happens save state and reload
  saveState(state, storage_key)
  // reload state and calculate stats
  state = loadState(storage_key);
  const stats = getChecklistStats(state);
  // recalculate progress
  updateOverviewProgress(stats);
  updateSectionProgress(stats);
}
